import { render, staticRenderFns } from "./NewsAbout.html?vue&type=template&id=571cdaf8&scoped=true&"
import script from "./NewsAbout.ts?vue&type=script&lang=ts&"
export * from "./NewsAbout.ts?vue&type=script&lang=ts&"
import style0 from "./NewsAbout.css?vue&type=style&index=0&id=571cdaf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571cdaf8",
  null
  
)

export default component.exports